export default "__VITE_ASSET__f03e4734__"